(function () {
  function initSubcollectionsSliders(scope = document) {
    // Seleziona tutte le sezioni subcollections
    const sliders = scope.querySelectorAll('.section-subcollections-slider');
    if (!sliders.length) return;

    sliders.forEach((block) => {
      const sliderEl = block.querySelector('.subcollections-slider');
      if (!sliderEl || sliderEl.dataset.initialized === 'true') return;

      // Evita doppia inizializzazione
      sliderEl.dataset.initialized = 'true';

      const nextEl = block.querySelector('.subcollections-slider-next');
      const prevEl = block.querySelector('.subcollections-slider-prev');

      // Opzioni coerenti con stile tema
      const options = {
        slidesPerView: 1.1,
        spaceBetween: 20,
        speed: 800,
        loop: false,
        grabCursor: true,
        navigation: { nextEl, prevEl },
        breakpoints: {
          568: { slidesPerView: 2.2, spaceBetween: 24 },
          1000: { slidesPerView: 2 },
          1024: { slidesPerView: 2.7, spaceBetween: 32 },
          1500: { slidesPerView: 4, spaceBetween: 32 },
        },
      };

      // Inizializzazione con wrapper nativo del tema
      const instance = new window.FoxTheme.Carousel(sliderEl, options);
      instance.init();
    });
  }

  // Inizializza su caricamento pagina e in modalità editor
  document.addEventListener('DOMContentLoaded', () => initSubcollectionsSliders());
  document.addEventListener('shopify:section:load', (e) => initSubcollectionsSliders(e.target));
})();
